import { useState, useEffect } from 'react';

const useAnimatedCounter = (targetValue, duration = 800) => {
    const [value, setValue] = useState(targetValue);

    // Ease-in-out function
    const easeInOut = (t) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    };

    useEffect(() => {
        let startTimestamp;
        const startValue = value;
        const endValue = targetValue;

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = (timestamp - startTimestamp) / duration;
            const easedProgress = easeInOut(progress); // Apply easing function to progress

            setValue(startValue + (endValue - startValue) * easedProgress);

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                setValue(targetValue); // Ensure it ends exactly at targetValue
            }
        };

        window.requestAnimationFrame(step);
    }, [targetValue, duration]);

    return Math.round(value);
};

export default useAnimatedCounter;